import React, { useState, useEffect } from "react";
import {
    getInventories,
    createInventory,
    updateInventory,
    deleteInventory,
} from "../../../../_api/Inventory"; // adapte le chemin si besoin
import { getSpaces } from "../../../../_api/Space";
import { uploadFile } from "../../../../_api/Storage"; // ton appel API S3

const etatColor = {
    Bon: "text-green-600 bg-green-100",
    "À réparer": "text-yellow-700 bg-yellow-100",
    "Hors service": "text-red-600 bg-red-100",
};

export const InventaireList = () => {
    const [recherche, setRecherche] = useState("");
    const [materiels, setMateriels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showSidebar, setShowSidebar] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [espaces, setEspaces] = useState([]);
    const [selectedEspace, setSelectedEspace] = useState("");

    useEffect(() => {
        const fetchEspaces = async () => {
            try {
                const res = await getSpaces();
                setEspaces(res.data);
            } catch (err) {
                console.error("Erreur de chargement des espaces", err);
            }
        };
        fetchEspaces();
    }, []);

    const fetchMateriels = async () => {
        setLoading(true);
        try {
            const res = await getInventories();
            setMateriels(res.data);
            setError(null);
        } catch (err) {
            setError("Erreur lors du chargement.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMateriels();
    }, []);

    const handleAdd = () => {
        setEditingItem(null);
        setShowSidebar(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Supprimer ce matériel ?")) return;
        try {
            await deleteInventory(id);
            fetchMateriels();
            setShowSidebar(false);
        } catch {
            alert("Erreur lors de la suppression");
        }
    };

    const handleSubmit = async (data) => {
        try {
            let fileKey = null;
            const payload = {
                ...data,
            };

            if (data.document instanceof File) {
                const formData = new FormData();
                formData.append("file", data.document);

                const response = await uploadFile(formData);
                fileKey = response?.data.path;
                payload["photo_url"] = fileKey;
            }

            if (editingItem) {
                await updateInventory(editingItem.id, payload);
            } else {
                await createInventory(payload);
            }

            fetchMateriels();
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l’enregistrement");
        }

        setShowSidebar(false);
    };

    const filteredMateriels = materiels.filter((item) =>
        item.name.toLowerCase().includes(recherche.toLowerCase())
    );

    return (
        <div className="p-6 mx-auto">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
                <h1 className="text-2xl font-bold">Inventaire du matériel</h1>
                <button
                    onClick={handleAdd}
                    className="p-2 rounded-full hover:bg-green-100 transition"
                    title="Ajouter un matériel"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 text-green-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 4v16m8-8H4"
                        />
                    </svg>
                </button>
            </div>

            <div className="flex">
                <div className="w-1/2">
                    <input
                        type="text"
                        placeholder="Rechercher un matériel..."
                        className="mb-4 w-full sm:w-1/2 px-4 py-2 border border-gray-300 rounded-lg"
                        value={recherche}
                        onChange={(e) => setRecherche(e.target.value)}
                    />
                    <select
                        value={selectedEspace}
                        onChange={(e) => setSelectedEspace(e.target.value)}
                        className="mb-4 w-full sm:w-1/2 px-4 py-2 border border-gray-300 rounded-lg"
                    >
                        <option value="">Tous les espaces</option>
                        {espaces.map((espace) => (
                            <option key={espace.id} value={espace.id}>
                                {espace.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {loading ? (
                <div className="text-center py-10 text-gray-500">
                    Chargement...
                </div>
            ) : error ? (
                <div className="text-center text-red-500">{error}</div>
            ) : (
                <>
                    {/* TABLEAU - sm+ */}
                    <div className="hidden sm:block overflow-x-auto">
                        <table className="min-w-full bg-white shadow-sm rounded-lg overflow-hidden">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="text-left px-4 py-3">Nom</th>
                                    <th className="text-left px-4 py-3">
                                        Catégorie
                                    </th>
                                    <th className="text-left px-4 py-3">
                                        Quantité
                                    </th>
                                    <th className="text-left px-4 py-3">
                                        Lieux
                                    </th>
                                    <th className="text-left px-4 py-3">
                                        État
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredMateriels.map((item) => (
                                    <tr
                                        key={item.id}
                                        className="border-t cursor-pointer"
                                        onClick={() => {
                                            setEditingItem(item);
                                            setShowSidebar(true);
                                        }}
                                    >
                                        <td className="px-4 py-2">
                                            {item.name}
                                        </td>
                                        <td className="px-4 py-2">
                                            {item.category}
                                        </td>
                                        <td className="px-4 py-2">
                                            {item.quantity}
                                        </td>
                                        <td className="px-4 py-2">
                                            {
                                                espaces.find(
                                                    (espace) =>
                                                        espace.id ===
                                                        item.space_id
                                                )?.name
                                            }
                                        </td>

                                        <td className="px-4 py-2">
                                            <span
                                                className={`px-2 py-1 rounded-full text-sm ${etatColor[item.state]
                                                    }`}
                                            >
                                                {item.state}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                                {filteredMateriels.length === 0 && (
                                    <tr>
                                        <td
                                            colSpan="5"
                                            className="text-center py-4 text-gray-500"
                                        >
                                            Aucun matériel trouvé.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* MOBILE */}
                    <div className="sm:hidden space-y-4">
                        {filteredMateriels.map((item) => (
                            <div
                                key={item.id}
                                className="p-4 border rounded-lg shadow-sm cursor-pointer"
                                onClick={() => {
                                    setEditingItem(item);
                                    setShowSidebar(true);
                                }}
                            >
                                <div className="flex justify-between items-center">
                                    <div className="font-semibold text-lg">
                                        {item.name}
                                    </div>
                                    <span
                                        className={`px-2 py-1 rounded-full text-sm ${etatColor[item.state]
                                            }`}
                                    >
                                        {item.state}
                                    </span>
                                </div>
                                <div className="text-sm text-gray-600 mb-1">
                                    {item.category}
                                </div>
                                <div className="text-sm">
                                    Quantité : {item.quantity}
                                </div>
                            </div>
                        ))}
                        {filteredMateriels.length === 0 && (
                            <div className="text-center text-gray-500">
                                Aucun matériel trouvé.
                            </div>
                        )}
                    </div>
                </>
            )}

            {showSidebar && (
                <SidebarForm
                    onClose={() => setShowSidebar(false)}
                    onSubmit={handleSubmit}
                    handleDelete={handleDelete}
                    initialData={editingItem}
                />
            )}
        </div>
    );
};

const SidebarForm = ({
    onClose,
    onSubmit,
    initialData = null,
    handleDelete,
}) => {
    const [form, setForm] = useState({
        name: "",
        category: "",
        quantite: "",
        comment: "",
        state: "Bon",
        space_id: "",
        document: null,
        ...initialData,
    });
    const [espaces, setEspaces] = useState([]);
    const [isZoomOpen, setIsZoomOpen] = useState(false);

    useEffect(() => {
        if (initialData) setForm(initialData);
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "document") {
            setForm((f) => ({ ...f, document: files[0] }));
        } else {
            setForm((f) => ({ ...f, [name]: value }));
        }
    };

    useEffect(() => {
        const fetchEspaces = async () => {
            try {
                const res = await getSpaces();
                setEspaces(res.data);
            } catch (err) {
                console.error("Erreur de chargement des lieux", err);
            }
        };
        fetchEspaces();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(form);
        onClose(); // auto-close après soumission
    };

    return (
        <div className="fixed inset-0 z-40 flex justify-end">
            <div className="w-full max-w-md bg-white shadow-xl p-6 overflow-y-auto z-50 relative animate-slide-in-right">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                    aria-label="Fermer la sidebar"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                <h2 className="text-xl font-bold mb-4">
                    {initialData
                        ? "Modifier le matériel"
                        : "Ajouter un matériel"}
                </h2>
                <div>
                    {(form.photo_url ||
                        (typeof form.photo_url === "string" &&
                            form.photo_url)) && (
                            <div
                                className="mb-4 cursor-pointer"
                                onClick={() => setIsZoomOpen(true)}
                            >
                                <img
                                    src={form.photo_url || form.photo_url}
                                    alt="Aperçu"
                                    className="w-full h-auto max-h-64 object-contain rounded-sm border hover:scale-105 transition-transform"
                                />
                            </div>
                        )}
                </div>
                <form className="space-y-4" onSubmit={handleSubmit}>
                    <div>
                        <label className="block mb-1">Nom</label>
                        <input
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            className="w-full border p-2 rounded-sm"
                            type="text"
                            required
                        />
                    </div>
                    <div className="flex">
                        <div className="w-1/2">
                            <label className="block">Catégorie</label>
                            <select
                                name="category"
                                value={form.category}
                                onChange={handleChange}
                                className="w-full border p-2 rounded-sm"
                                required
                            >
                                <option value="">-- Sélectionner --</option>
                                <option>Mobilier</option>
                                <option>Audio</option>
                                <option>Vidéo</option>
                                <option>Extérieur</option>
                                <option>Divers</option>
                            </select>
                        </div>
                        <div className="w-1/2">
                            <label className="block font-medium">Lieu</label>
                            <select
                                name="space_id"
                                value={form.space_id}
                                onChange={handleChange}
                                className="w-full border px-3 py-2 rounded-sm"
                            >
                                <option value="">-- Choisir un lieu --</option>
                                {espaces.map((e) => (
                                    <option key={e.id} value={e.id}>
                                        {e.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div>
                        <label className="block mb-1">Quantité</label>
                        <input
                            name="quantity"
                            value={form.quantity}
                            onChange={handleChange}
                            className="w-full border p-2 rounded-sm"
                            type="number"
                            min="0"
                            required
                        />
                    </div>

                    <div>
                        <label className="block mb-1">État</label>
                        <select
                            name="state"
                            value={form.state}
                            onChange={handleChange}
                            className="w-full border p-2 rounded-sm"
                            required
                        >
                            <option value="">-- Sélectionner --</option>
                            <option>Bon</option>
                            <option>À réparer</option>
                            <option>Hors service</option>
                        </select>
                    </div>

                    <div>
                        <label className="block font-medium">
                            Fichier (image...)
                        </label>
                        <input
                            type="file"
                            accept="image/*"
                            name="document"
                            onChange={handleChange}
                            className="w-full border px-3 py-2 rounded-sm"
                        />
                    </div>

                    <div>
                        <label className="block mb-1">Commentaire</label>
                        <textarea
                            name="comment"
                            value={form.comment}
                            onChange={handleChange}
                            className="w-full border p-2 rounded-sm"
                            rows={3}
                            placeholder="Note interne sur l’état ou la disponibilité"
                        />
                    </div>

                    <div className="text-right">
                        <button
                            type="button"
                            onClick={onClose}
                            className="m-1 border-2 border-gray-400 text-gray-400 hover:border-gray-600 hover:text-gray-600 max-h-12 rounded-sm font-bold py-2 px-4 focus:outline-hidden focus:shadow-outline"
                        >
                            Annuler
                        </button>
                        {initialData && (
                            <button
                                className="m-1 border-2 border-red-500 text-red-500 hover:border-red-700 hover:text-red-700 max-h-12 rounded-sm font-bold py-2 px-4 focus:outline-hidden focus:shadow-outline"
                                onClick={() => handleDelete(initialData.id)}
                            >
                                Supprimer
                            </button>
                        )}

                        <button
                            type="submit"
                            className="m-1 border-2 border-app-primary text-app-primary hover:border-app-secondary hover:text-app-secondary max-h-12 rounded-sm font-bold py-2 px-4 focus:outline-hidden focus:shadow-outline"
                        >
                            {initialData ? "Mettre à jour" : "Ajouter"}
                        </button>
                    </div>
                </form>
            </div>
            {isZoomOpen && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center"
                    onClick={() => setIsZoomOpen(false)}
                >
                    <img
                        src={form.photo_url || form.photo_url}
                        alt="Zoom"
                        className="max-w-4xl max-h-[90vh] object-contain rounded-sm shadow-lg"
                    />
                </div>
            )}
        </div>
    );
};
